const FooterLoading = () => (
    <div className="flex justify-center items-center py-12">
        <div className="flex flex-col items-center gap-4">
            <div className="w-12 h-12 border-4 border-[#3032D4] border-t-transparent rounded-full animate-spin"></div>
            <p className="text-[#3032D4] font-bold text-lg">در حال بارگذاری...</p>
        </div>
    </div>
);

export default FooterLoading;